<template>
  <q-card flat>
    <q-card-section class="no-padding">
      <q-banner class="bg-blue text-white">
        رهگیری سفارشات خرید و فروش
      </q-banner>
    </q-card-section>
    <q-card-section class="no-padding">
      <q-tabs
          v-model="tab"
          class="bg-indigo text-white"
          align="justify"
          narrow-indicator
          no-caps
          inline-label
      >
        <q-tab name="sellOrder" icon="shopping_basket" label="فروش" />
        <q-tab name="buyOrder" icon="shopping_basket" label="خرید" />
      </q-tabs>
      <q-tab-panels v-model="tab" animated class="bg-indigo-1 text-center">
        <q-tab-panel name="sellOrder" class="no-padding">
          <OrderTrace :admin-view="true" />
        </q-tab-panel>

        <q-tab-panel name="buyOrder" class="no-padding">
          <BuyOrderTrace />
        </q-tab-panel>
      </q-tab-panels>
    </q-card-section>
  </q-card>
</template>

<script>
import OrderTrace from "@/components/OrderTrace/OrderTrace";
import BuyOrderTrace from "@/components/Buys/BuyOrderTrace";
export default {
  name: "FullView",
  components: {BuyOrderTrace, OrderTrace},
  data(){
    return{
      tab: 'sellOrder',
    }
  }
}
</script>

<style scoped>

</style>